<!-- Input con contraseña para uso estricto -->
@if (estricto) {
  <div class="input-container relative mt-6 group">
    <input
      pInputText
      [type]="tipo"
      [step]="tipo === 'number' ? 'any' : null"
      [id]="id"
      class="rounded-none rounded-t-md focus:shadow-none"
      [(ngModel)]="valor"
      (ngModelChange)="stringValido($event)"
      (focus)="show = true"
      (blur)="sendOnBlur($event); show = false; trim()"
    />
    <label
      for="input"
      class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none"
      [ngClass]="{
        'label-focus': show || (valor() !== undefined && valor() !== ''),
      }"
    >
      {{ etiqueta }}
    </label>
    <label
      class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none group-focus-within:opacity-100 opacity-0"
      [ngClass]="{ 'place-focus': valor() !== undefined && valor() !== '' }"
    >
      {{ placeholder }}
    </label>
    <div class="underline"></div>
    @if (contrasenia) {
      <img
        (click)="toggleContrasenia()"
        [src]="icon.icon"
        [alt]="icon.alt"
        width="20"
        animate.enter="fade-enter"
        style="--time: 100ms"
        animate.leave="fade-leave"
        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer"
      />
    }
  </div>
  <div style="display: flex; justify-content: start; flex-direction: column">
    <p
      class="m-0 text-start pl-2"
      [ngClass]="{
        'text-red-600': !hasUpperCase,
        'text-green-600': hasUpperCase,
      }"
    >
      <small class="flex items-center justify-start">
        @if (hasUpperCase) {
          <img src="/svg/check.svg" alt="Check" width="12" />
        } @else {
          <img src="/svg/close.svg" alt="Check" width="12" />
        }
        <b>Debe contener 1 letra mayúscula</b>
      </small>
    </p>
    <p
      class="m-0 text-start pl-2"
      [ngClass]="{
        'text-red-600': !hasSpecialChar,
        'text-green-600': hasSpecialChar,
      }"
    >
      <small class="flex items-center justify-start">
        @if (hasSpecialChar) {
          <img src="/svg/check.svg" alt="Check" width="12" />
        } @else {
          <img src="/svg/close.svg" alt="Check" width="12" />
        }
        <b>Debe contener al menos 1 carácter especial</b>
      </small>
    </p>
    <p
      class="text-start m-0 p-0 pl-2"
      [ngClass]="{ 'text-red-600': !isLength, 'text-green-600': isLength }"
    >
      <small class="flex items-center justify-start">
        @if (isLength) {
          <img src="/svg/check.svg" alt="Check" width="12" />
        } @else {
          <img src="/svg/close.svg" alt="Check" width="12" />
        }
        <b>8 caracteres como mínimo</b>
      </small>
    </p>
    <p
      class="text-start m-0 p-0 pl-2"
      [ngClass]="{ 'text-red-600': !hasNumbers, 'text-green-600': hasNumbers }"
    >
      <small class="flex items-center justify-start">
        @if (hasNumbers) {
          <img src="/svg/check.svg" alt="Check" width="12" />
        } @else {
          <img src="/svg/close.svg" alt="Check" width="12" />
        }
        <b>4 números como mínimo</b>
      </small>
    </p>
    <p
      class="text-start m-0 p-0 pl-2"
      [ngClass]="{
        'text-red-600': !nonConsecutive || !nonRepetitive,
        'text-green-600': nonConsecutive && nonRepetitive,
      }"
    >
      <small class="flex items-center justify-start">
        @if (nonConsecutive && nonRepetitive) {
          <img src="/svg/check.svg" alt="Check" width="12" />
        } @else {
          <img src="/svg/close.svg" alt="Check" width="12" />
        }
        <b>
          Números no consecutivos (e.j. 1234 ó 4321) ni repetitivos (e.j. 1111)
        </b>
      </small>
    </p>
  </div>
} @else {
  <div
    class="input-container relative mt-6 group rounded-t-md"
    [ngClass]="{
      'border-t-red-600 border-r-red-600 border-l-red-600 border':
        (showError && (valor() === undefined || valor() === '')) || hardError,
    }"
  >
    <input
      pInputText
      [type]="tipo"
      [step]="tipo === 'number' ? 'any' : null"
      [id]="id"
      class="rounded-none rounded-t-md focus:shadow-none"
      #input
      [(ngModel)]="valor"
      (focus)="show = true"
      (blur)="sendOnBlur($event); show = false; trim()"
      [readonly]="readonly"
      (input)="replace(input)"
      [max]="max"
      [ngClass]="{
        'text-tertiary-600': nivelRelevancia == 'bajo',
        'text-secondary-600': nivelRelevancia == 'medio',
        'text-primary-700': nivelRelevancia == 'alto',
      }"
    />
    <label
      class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none"
      [ngClass]="{
        'label-focus': show || (valor() !== undefined && valor() !== ''),
      }"
    >
      {{ etiqueta }}
    </label>
    <label
      class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none group-focus-within:opacity-100 opacity-0"
      [ngClass]="{ 'place-focus': valor() !== undefined && valor() !== '' }"
    >
      {{ placeholder }}
    </label>
    <div class="underline" [ngClass]="{ 'underline-focus': show }"></div>
    @if (contrasenia) {
      <img
        (click)="toggleContrasenia()"
        [src]="icon.icon"
        [alt]="icon.alt"
        width="20"
        animate.enter="fade-enter"
        style="--time: 100ms"
        animate.leave="fade-leave"
        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer"
      />
    }
    <!-- Ícono para abrir modal -->
    @if (showModalIcon) {
      <img
        src="svg/pencil.svg"
        alt="Abrir modal"
        width="20"
        (click)="clickModalIcon.emit()"
        class="absolute top-1/2 -translate-y-1/2 cursor-pointer right-2"
      />
    }
  </div>
  <div
    class="hide"
    [ngClass]="{
      show:
        (showError && (valor() === undefined || valor() === '')) || hardError,
    }"
  >
    <div>
      <small class="flex justify-start items-center text-red-600 mt-1">
        <svg
          width="10px"
          height="10px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mr-0.5"
        >
          <path
            d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
            stroke="#dc2626"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
            stroke="#dc2626"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        {{ mensajeError }}
      </small>
    </div>
  </div>
}
